import { render } from "./profil.vue?vue&type=template&id=3da7665c&scoped=true"
import script from "./profil.vue?vue&type=script&lang=js"
export * from "./profil.vue?vue&type=script&lang=js"

import "./profil.vue?vue&type=style&index=0&id=3da7665c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da7665c"]])

export default __exports__